@if (showPanelWithoutSlideout) {
    <ng-template [ngTemplateOutlet]="filtersSlideout"></ng-template>
}

<ng-template #filtersSlideout>
    @if (showPanelWithoutSlideout) {
        <lg-slideout-holder-header>
            <ng-template [ngTemplateOutlet]="filtersSlideoutHeaderIcons" />
        </lg-slideout-holder-header>
    }
    @if (!_visibleFilterSet || !_filterSetStateKey) {
        <div [lgLoaderOverlay]="true" [style.width.%]="100" [style.height.%]="100"></div>
    }
    @if (_visibleFilterSet && _filterSetStateKey) {
        <div
            lgArrowNavigation
            [horizontalNavigation]="false"
            class="lg-filters-panel__wrapper flexcol"
        >
            @if (!disableSearch) {
                <div class="lg-filters-panel__search">
                    <lg-icon icon="icon-search"></lg-icon>
                    <input
                        type="text"
                        [ngModel]="_quicksearch"
                        (ngModelChange)="_updateSearch($event)"
                        [placeholder]="'.Search' | lgTranslate"
                        lgSelectOnFocus
                        class="input input--no-highlight input--no-border input--no-shadow"
                        #searchInput
                        (keydown)="_searchKeyDown($event)"
                    />
                    @if (_quicksearch) {
                        <lg-icon
                            icon="icon-close"
                            (click)="_clearSearch($event)"
                            [clickable]="true"
                        ></lg-icon>
                    }
                </div>
            }
            <div
                class="lg-filters-panel__body flexcol"
                [class.lg-filters-panel__body--with-search]="!disableSearch"
                (keydown.escape)="_escapePressed($any($event))"
            >
                <div
                    lgScrollable
                    [lgScrollableWrapper]="false"
                    class="flex-stretch"
                    #scroller="lgScrollable"
                    #scrollerElement
                >
                    @for (
                        group of _groups;
                        track _groupIdentity($index, group);
                        let first = $first, last = $last
                    ) {
                        <div
                            class="lg-filters-panel__group"
                            [class.lg-filters-panel__group--empty]="!group.filters?.length"
                            [ngClass]="{ hasTitle: group.name, first: first, last: last }"
                            (keydown.arrowright)="_setGroupExpandedByKey($any($event), group, true)"
                            (keydown.arrowleft)="
                                _setGroupExpandedByKey($any($event), group, false, groupTitle)
                            "
                            (keydown.enter)="_setGroupExpandedByKey($any($event), group)"
                        >
                            <div
                                class="lg-filters-panel__group__title--wrapper"
                                [class.lg-filters-panel__group__title--wrapper_first]="first"
                                [class.lg-filters-panel__group__title--wrapper_empty]="!group.name"
                                [attr.tabindex]="group.name ? 0 : null"
                                #groupTitle
                            >
                                @if (group.name) {
                                    <div
                                        class="lg-filters-panel__group__title"
                                        (click)="_toggleGroup(group)"
                                        [class.lg-filters-panel__group__title--expanded]="
                                            _expanded[group.index]
                                        "
                                    >
                                        {{ group.name }}
                                        @if (_counts[group.index]) {
                                            <span class="lg-filters-panel__group__title__count">{{
                                                _counts[group.index]
                                            }}</span>
                                        }
                                        <lg-icon
                                            icon="icon-arrow-down"
                                            class="lg-filters-panel__group__title__icon"
                                            [class.lg-filters-panel__group__title__icon--expanded]="
                                                _expanded[group.index]
                                            "
                                        ></lg-icon>
                                    </div>
                                }
                            </div>
                            @if (!group.name || _expanded[group.index]) {
                                @for (entry of group.filters; track _entryIdentity($index, entry)) {
                                    <div
                                        class="lg-filters-panel__row"
                                        [attr.lg-filter-id]="entry.id"
                                    >
                                        <lg-filterset-list-item
                                            [definition]="entry"
                                            [list]="_visibleFilterSet"
                                            (filterChange)="_filterChanged(entry)"
                                        ></lg-filterset-list-item>
                                    </div>
                                }
                            }
                        </div>
                    }
                    @if (_emptySearch) {
                        <div class="lg-filters-panel__empty">
                            {{ ".No_matching_filter" | lgTranslate }}
                            <a href="#" (click)="_clearSearch($event)">
                                {{ ".Clear_search" | lgTranslate }}
                            </a>
                        </div>
                    }
                </div>
            </div>
            <ng-container *ngTemplateOutlet="_customFooterTemplate"></ng-container>
        </div>
    }
</ng-template>

<ng-template #filtersSlideoutTabButton>
    <button class="button button--primary lg-filters-panel__header__button" (click)="_hide(true)">
        {{ ".Filters" | lgTranslate }}
        @if (_totalCount > 0) {
            <span class="lg-filters-panel__header__button__circle">
                {{ _totalCount }}
            </span>
        }
    </button>
</ng-template>

<ng-template #filtersSlideoutHeaderIcons>
    <lg-icon
        [ngClass]="_isAnyFilterActive ? 'lg-icon-menu' : ''"
        icon="icon-erase"
        [type]="_isAnyFilterActive ? 'regular' : 'disabled'"
        [tabIndex]="0"
        (click)="_clearAll()"
        (keydown.enter)="_clearAll()"
    >
    </lg-icon>
    @if (!disableViewCustomization) {
        <lg-icon-menu
            class="lg-icon-menu__default"
            [definition]="_viewMenuDefinition"
            [current]="_viewMode"
            (currentChange)="_setViewMode($event)"
            [icon]="null"
            [focusEnabled]="true"
        />
    }
    @if (!disableBookmarks && _visibleFilterSet != null) {
        <lg-bookmarks-menu
            [filterSet]="_visibleFilterSet"
            [filterSetStateKey]="_filterSetStateKey!"
        />
    }
</ng-template>
